import { render } from "./DeleteFormUsuario.vue?vue&type=template&id=1551056c"
import script from "./DeleteFormUsuario.vue?vue&type=script&lang=js"
export * from "./DeleteFormUsuario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__